import { groq } from '#imports';

export function getQuery({ slug }) {
  return groq`*[_type == "theme" && slug.current == "${slug}" && !(_id in path('drafts.**'))][0]{
      ...,
      'uuid': true,
      content,
    }`;
}
